import { useState, useEffect, useCallback, useMemo } from 'react'
import { ErrorConstant } from 'utility'
import { MenuSettingService } from 'utility/services/menu-setting'

export const GetMenuList = (extraQueryParams = {}) => {
    const [data, setData] = useState([])
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)

    const options = useMemo(
        () =>
            data
                .filter(ele => ele.ParentMenuId === null)
                .map(ele => ({
                    value: ele.MenuId,
                    text: ele.Title,
                })),
        [data],
    )

    const fetchData = useCallback(async () => {
        try {
            setLoading(true)
            setError('')

            const result = await MenuSettingService.list({
                onlyActive: false,
                onlyVisible: false,
                ...extraQueryParams,
            })

            setData(result.sort((a, b) => a.MenuId - b.MenuId))
        } catch (err) {
            setError(ErrorConstant.default)
        } finally {
            setLoading(false)
        }
    }, [JSON.stringify(extraQueryParams)])

    useEffect(() => {
        fetchData()
    }, [fetchData])

    const refresh = () => {
        fetchData()
    }

    return { data, setData, error, loading, refresh, options }
}

export const GetMenuPermissionList = menuId => {
    const [data, setData] = useState([])
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)

    const fetchData = useCallback(async (showLoader = true) => {
        try {
            if (showLoader) setLoading(true)
            setError('')

            const result = await MenuSettingService.menuPermission(menuId)
            setData(result)
        } catch (err) {
            setError(ErrorConstant.default)
        } finally {
            setLoading(false)
        }
    }, [menuId])

    useEffect(() => {
        if (menuId) {
            fetchData(true)
        }
    }, [menuId])

    const refresh = (showLoader = true) => {
        fetchData(showLoader)
    }

    return { data, setData, error, loading, refresh }
}
